import ActionButtons from './ActionButtons';
import { actionButtonsComiteeName } from './ActionButtons/actionButtonsArray';

function EuPubControlDecision({ committee, step, offerId }) {
  return (
    <ActionButtons
      buttonType={actionButtonsComiteeName.euPubControlDecision}
      committee={committee}
      step={step}
      offerId={offerId}
    />
  );
}
export default EuPubControlDecision;
